import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { createPinia } from 'pinia';
import piniaPersistedState from 'pinia-plugin-persistedstate';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import './styles/main.scss';
import { setupPermissionsDirective } from './directives/permissions';
import currencyPlugin from '@/plugins/currency';
import dateTimePlugin from '@/plugins/datetime';
import acl from '@/plugins/acl'

// Pinia store setup
import { useAuthStore } from '@/store/auth';
import { useThemeStore } from './store/themeStore';

import VueApexCharts from "vue3-apexcharts";


const hostname = window.location.hostname;
const isBlitzhub = hostname.includes('blitzhub');
document.title = isBlitzhub ? 'blitzHub' : 'clienTOR';


// Load fonts
loadFonts();

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPersistedState);
app.use(pinia); // ✅ Ensure Pinia is registered before using stores

const authStore = useAuthStore();

authStore.initializeUser().then(() => {
  app.use(router); // ✅ Register router before mounting
  app.use(vuetify);
  app.use(currencyPlugin);
  app.use(dateTimePlugin);
  app.use(acl); // ✅ Register Vuetify before mounting
  app.component('apexchart', VueApexCharts);
  setupPermissionsDirective(app); // ✅ Setup directives before mounting

  //vuetify.theme.global.name.value = 'dark';
  // Theme store setup
  const themeStore = useThemeStore();
  themeStore.initTheme();

  // ✅ Finally, mount the app
  app.mount('#app');
});
